if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      if (AfcTheme.config.motionReduced) return;
      this.promotion = this.querySelector('.promotion');
      AfcTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
    init() {
      if (this.childElementCount === 1) {
        const totalWidth = window.innerWidth * 2;
        const promoWidth = this.promotion.offsetWidth;
        const clonesNeeded = Math.ceil(totalWidth / promoWidth);

        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < clonesNeeded; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.clone.classList.add('promotion--duplicate');
          this.appendChild(this.clone);
        }

        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              entry.isIntersecting ? this.play() : this.pause();
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    play() {
      this.classList.remove('scrolling-promotion--paused');
    }

    pause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
